import React, { Component } from 'react';
import Sidebar from '../../Components/Sidebar';
import Btn from '../../Components/Btn';
import DatePicker from '../../Components/DatePicker';
import ListView from './Components/ListView';
import CalendarView from './Components/CalendarView';

export default class Trips extends Component {

    state = {
        listView: true,
        calendarView: false,
        dateActive: false
    };

    toggleDateRangeClasses = () => {
        this.setState({ dateActive: !this.state.dateActive });
    };

    toggleListView = () => {
        this.setState({ listView: !this.state.listView,calendarView: !this.state.calendarView });
    };
    toggleCalendarView = () => {
        this.setState({ calendarView: !this.state.calendarView,listView: !this.state.listView });
    };
    
  render() {
    let dateClasses = (this.state.dateActive) ? "active" : "";
    let listViewBtnClasses = (this.state.listView) ? "active" : "";
    let calendarViewBtnClasses = (this.state.calendarView) ? "active" : "";
    return (
      <div className="wrapper">
        <Sidebar/>
        <div className="main-panel">
          <div className="page-title">
            <div className="page-title-heading">
              <h1>Trips</h1>
            </div>
            <div className="page-title-actions">
                <form action="#">
                    <div className="form-field">
                        <h5 className="label">Date Range</h5>
                        <div className="date-box">
                            <p className="date-box-text" onClick={(event) => { event.preventDefault(); this.toggleDateRangeClasses() }}>May 15, 2017 - May 15, 2017<i className="material-icons">date_range</i></p>
                            <div className={`DatePickerParent ${dateClasses}`}>
                                <DatePicker/>
                            </div>
                        </div>
                    </div>
                    <div className="form-field">
                        <h5 className="label">Search</h5>
                        <input type="search" placeholder="Trip No."/>
                    </div>
                    <div className="form-field">
                        <Btn className="btn simple small">Search</Btn>
                    </div>
                </form>
            </div>
          </div>
          <div className="trips-content">
              <div className="trips-view-actions">
                <Btn className={`btn icon ${listViewBtnClasses}`} onClick={(event) => { event.preventDefault(); this.toggleListView() }}><img src="/imgs/icons/menu.png" alt="menu icon" width="15"/></Btn>
                <Btn className={`btn icon ${calendarViewBtnClasses}`} onClick={(event) => { event.preventDefault(); this.toggleCalendarView() }}><img src="/imgs/icons/calendar.png" alt="calendar icon" width="16"/></Btn>
              </div>
              {this.state.listView ? 
                <ListView/>
                :
                <div className="calander">
                <CalendarView/>
                </div>
              }
          </div>
        </div>
      </div>
    );
  }
}
